import React from 'react';
import  {IndexLink,Link} from 'react-router';
import {isMobile} from 'react-device-detect';

const Footer2Component = () => (
  <footer className="footer2">
  {isMobile != 1?
    <div className="splash_footer">
        <div className="wrapper row">
            <div className="col-xs-4 logo-footer">
                <img alt="VERSITY" src="/static/img/appimg/top_login_h_logo.png"/>
                <p className="splash_footer_logo2">&copy; 2025 Versity, Inc.</p>
            </div>
            <div className="col-xs-8">
                <ul className="splash_nav2">
                    <li>LEARN MORE</li>
                    <li><Link to="/companies">Employers</Link></li>
                    <li><Link to="/highered/contact-us">Universities</Link></li>
                    <li><Link to="/students">Students</Link></li>
                </ul>
                <ul className="splash_nav2">
                    <li>COMPANY</li>
                    <li><Link to="/career">Work at Versity</Link></li>
                    <li><Link to="/company/130098">About Us</Link></li>
                    <li><Link to="/press-releases">In the News</Link></li>
                </ul>
                <ul className="splash_nav2">
                    <li>HELP & SUPPORT</li>
                    <li><Link to="/talent/contact-us">Contact Us</Link></li>
                    <li><a target="_blank" href="/blog/">Blog</a></li>
                </ul>
                <ul className="splash_nav2">
                    <li>LEGAL</li>
                    <li><Link to="/privacy">Privacy Policy</Link></li>
                    <li><Link to="/projectterms">Terms of Use</Link></li>
                </ul>
            </div>
        </div>
    </div>
  :
  <div className="footer-mobile">
      <div className="col-xs-12"> 
          <ul className="splash_nav2">
              <li>OUR USERS</li>
              <li><Link to="/highered/contact-us">Universities</Link></li>
              <li><Link to="/companies">Employers</Link></li>
              <li><Link to="/students">Students</Link></li>
          </ul>
          <ul className="splash_nav2">
              <li>OTHER</li>
              <li><a target="_blank" href="/blog/">Blog</a></li>
              <li><Link to="/projectterms">Terms of Service</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
          </ul>
      </div>
      <div className="col-xs-12">
         <span> © 2025 Versity Inc. All rights reserved.</span>
      </div>
  </div>}
</footer>
);

export default Footer2Component;


/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/commons/footer2.js
 **/